// import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { useState, useMemo } from "react"
import { Link } from "@/router"
import { useAuth } from "@/services/userService"
import { Button } from "@/components/ui/button";
import { AButton } from "@/components/ui/abutton";
import { Menu, X, Search, LogOut } from "lucide-react";
import { motion } from "framer-motion";


// eslint-disable-next-line react/prop-types
export default function NavBar({menuOpen, setMenuOpen}) {

    const { auth } = useAuth()

    const [searchOpen, setSearchOpen] = useState(false)

    const isLoggedIn = useMemo(() => {
        return auth.isAuthenticated
    }, [auth.isAuthenticated])

    return (
    
        <div className="flex justify-between items-center p-4 bg-white shadow-md z-30">
            <div className="flex items-center gap-4">
                {/* Bouton de menu seulement si connecté */}
                {isLoggedIn && (
                    <Button variant="ghost" onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <X size={24} /> : <Menu size={24} />}
                    </Button>
                )}
                <img src="/wsfr.png" className="h-10"/>
            </div>
            <div className="flex items-center gap-4">
                
                {/* Si connecté, on affiche le menu utilisateur et le bouton de recherche */}
                {isLoggedIn && (
                    <div className={`flex ${searchOpen ? "border rounded-lg" : ""}`}>
                        <motion.input
                            initial={{width: 0}}
                            animate={{width: searchOpen ? 256 : 0}}
                            transition={{ type: "tween", duration: 0.3 }}
                            className={`border-0 focus:border-0 focus:ring-0 ml-1 ${searchOpen ? "w-64" : "w-0"}`}
                            type="text"
                            placeholder="Rechercher..."
                        />
                        <Button variant="ghost">
                            <Search size={20} onClick={() => setSearchOpen(!searchOpen)} />
                        </Button>
                    </div>
                )}
                {isLoggedIn && (
                    <Link className="flex text-primary" to="/logout" title="Se déconnecter" lang="fr"><LogOut size={20} />{auth.fromIdp}</Link>
                )}

                {/* Si non connecté, on affiche le bouton de connexion */}
                {!isLoggedIn && (
                    <AButton className="bg-blue-500 text-white" href="/login" lang="fr">Se connecter</AButton>
                )}
                
            </div>
           
        </div>

    )

}